<template>
  <div class="appointment-container p-25" v-if="rolesAccessPermission()">
    <div class="row align-items-center mb-10">
      <!-- Search Start -->
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
        <div class="form-group has-feedback mb-0">
          <input type="text" class="form-control mb-0 br-3 search-field" placeholder="Search" v-model="searchTerm" @keyup.enter="filterAppointments()" />
        </div>
      </div>
      <!-- Search End-->

      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-6 d-flex align-items-center">
        <!--  Calendar start-->
        <div class="col-xs-6 col-sm-4 col-md-4 col-lg-6 weekly-navigation font-weight-bold">
          <div v-if="!isLoadingAppointment">
            <span @click="previousWeekList" class="fa fa-chevron-left arrowColor"></span>

            <span class="week-date ml-12 mr-12 text-uppercase">{{ weekDateString }}</span>

            <span @click="nextWeekList" class="fa fa-chevron-right arrowColor"></span>
          </div>
          <div v-if="isLoadingAppointment">Loading...</div>
        </div>
        <!--  Calendar end-->
        <!-- Filter by type start-->
        <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4 fs-14 select_section">
          <select class="form-control br-3 input-bg select_control" v-model="filterVisitType" v-on:change="filterAppointments()">
            <option disabled value>Filter by type</option>
            <option value>All</option>
            <option v-for="visitType in visitTypeList.slice().sort()" :value="visitType" :key="visitType">{{ showVisitTypeDesc(visitType) }}</option>
          </select>
        </div>
        <!-- Filter by type end-->
      </div>
      <!-- Availability, New TH call Buttons start-->
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 text-right">
        <router-link v-if="isVisitsConfiguredInStudy && !canSiteDataLockAccess && !canInterviewerAccess && !user.readOnly" tag="button" class="btn btn-outline-primary btn-sm ml-auto availability-btn" :to="{ name: 'study-participant-availability' }">Availability</router-link>
        <button v-if="!canSiteDataLockAccess && !user.readOnly" type="button" class="btn btn-health new-video-call-btn ml-12" @click="showParticipantModal" :disabled="getVideoCallStatus">
          New Telehealth Call
        </button>
      </div>
      <!-- Availability, New TH call Buttons end-->
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="appointments">
          <div class="list-header pt-5 pb-5">
            <div class="row pr-10">
              <div class="col-lg-10 d-flex align-items-center">
                <span class="week-date fw-25">The list will be updated in every 90 seconds, and the most latest update was less than {{ lastUpdateTime }}</span>
              </div>
              <div class="col-sm-2 col-md-2 col-lg-2 col-xs-2 p-0 show_section text-right">
                <select v-model="selectedShowOption" class="input-bg select_control mb-3 fs-12 form-control form-control-md custom-select custom-select-md" @change="filterAppointments">
                  <option v-for="(option, index) in DataTableListOptions" v-bind:value="option.value" :key="index">
                    {{ option.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <!--Table-->
          <div class="wrapper height-500 position-relative">
            <div v-if="!appointmentList.length" class="text-muted align-self-center p-20 text-center response-msg">
              {{ responseListMsg }}
            </div>
            <table v-else class="table pb-20 mb-50">
              <thead class="table-border fs-12">
                <tr>
                  <th class="heading-color w-100 cursor_pointer"></th>

                  <th class="heading-color w-160 cursor_pointer" @click="sortList('visitType')">
                    <span class="pr-3 position-relative">
                      Type
                      <span class="sortUp">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[appointmentFilterData['visitType'] === true ? 'link-color' : '']"></i>
                      </span>
                      <span class="sortDown">
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[appointmentFilterData['visitType'] === false ? 'link-color' : '']"></i>
                      </span>
                    </span>
                  </th>
                  <th class="heading-color w-200 cursor_pointer" @click="sortList('visitName')">
                    <span class="pr-3 position-relative">
                      Name
                      <span class="sortUp">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[appointmentFilterData['visitName'] === true ? 'link-color' : '']"></i>
                      </span>
                      <span class="sortDown">
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[appointmentFilterData['visitName'] === false ? 'link-color' : '']"></i>
                      </span>
                    </span>
                  </th>
                  <th class="heading-color w-160 cursor_pointer" @click="sortList('userDefineParticipantId')">
                    <span class="pr-3 position-relative">
                      Participant ID
                      <span class="sortUp">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[appointmentFilterData['userDefineParticipantId'] === true ? 'link-color' : '']"></i>
                      </span>
                      <span class="sortDown">
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[appointmentFilterData['userDefineParticipantId'] === false ? 'link-color' : '']"></i>
                      </span>
                    </span>
                  </th>
                  <th class="heading-color cursor_pointer pl-16" @click="sortList('participantId')">
                    <span class="pr-3 position-relative">
                      THREAD ID
                      <span class="sortUp">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[appointmentFilterData['participantId'] === true ? 'link-color' : '']"></i>
                      </span>
                      <span class="sortDown">
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[appointmentFilterData['participantId'] === false ? 'link-color' : '']"></i>
                      </span>
                    </span>
                  </th>
                  <th class="heading-color cursor_pointer pl-16" @click="sortList('appointementTimeUtc')">
                    <span class="pr-3 position-relative">
                      Visit Date
                      <span class="sortUp">
                        <i class="fa fa-angle-up" aria-hidden="true" :class="[appointmentFilterData['appointementTimeUtc'] === true ? 'link-color' : '']"></i>
                      </span>
                      <span class="sortDown">
                        <i class="fa fa-angle-down" aria-hidden="true" :class="[appointmentFilterData['appointementTimeUtc'] === false ? 'link-color' : '']"></i>
                      </span>
                    </span>
                  </th>

                  <th class="heading-color w-160 cursor_pointer pl-16">
                    <span class="pr-3 position-relative">
                      Change Status
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(appointment, index) in appointmentList" :key="index">
                  <td class="table-content-color text-center">
                    <span
                      v-if="
                        !getVideoCallStatus &&
                          !isCallBtnDisabled &&
                          appointment.invitedInTelehealthVisit &&
                          appointment.visitType.toLowerCase() == 'telehealth' &&
                          ((appointment.type == 'scheduled' && (appointment.status == 'NotStarted' || appointment.status == 'InProgress' || appointment.status == 'In Progress') && showJoinCallBtn(appointment)) || (appointment.type == 'unscheduled' && (appointment.status == 'NotStarted' || appointment.status == 'InProgress' || appointment.status == 'In Progress')))
                      "
                      @click="initateVideoCall(appointment)"
                      class="status join-call"
                      >Join call</span
                    >
                    <span v-else-if="appointment.visitType.toLowerCase() == 'telehealth' && (appointment.type == 'scheduled' || appointment.type == 'unscheduled') && (appointment.status == 'InProgress' || appointment.status == 'In Progress') && !appointment.invitedInTelehealthVisit && isCallBtnDisabled" class="status In-progress-call">In-Progress</span>
                    <span v-else class="status" :class="showVisitStatusDesc(appointment).toLowerCase()">{{ showVisitStatusDesc(appointment) }}</span>
                  </td>
                  <td>
                    <span class="visit-type-field" :class="addVisitTypeIcon(appointment.visitType)" alt="Visit type"></span>
                    <span class="visit-type-field">
                      <b>{{ showVisitTypeDesc(appointment.visitType) }}</b>
                    </span>
                  </td>
                  <td>
                    <span v-if="appointment.visitType.toLowerCase() === 'homevisit' || appointment.visitType.toLowerCase() === 'phonecall' || appointment.configFor === 'site'" class="visitNameText" @click="showPhoneVisitDetails(appointment)">{{ appointment.name }}</span>
                    <span v-else>{{ appointment.type.toLowerCase() == "unscheduled" ? "On Demand" : appointment.name }}</span>

                    <!-- when archive list length is greater then 1 then show popover -->
                    <span v-if="appointment.archiveList && appointment.archiveList.length > 1 && isSiteTeamAccess">
                      <span :id="appointment.id" tabindex="0" class="camera" v-if="appointment.type.toLowerCase() == 'unscheduled' && appointment.archiveList != null">
                        <span
                          class="double-camera"
                          :class="{
                            'double-green': appointment.id == mainActiveArchiveId
                          }"
                          >{{ appointment.archiveList != null && appointment.archiveList.length > 1 ? appointment.archiveList.length : "" }}</span
                        >
                      </span>
                      <span :id="appointment.id" tabindex="0" class="camera" v-if="appointment.type.toLowerCase() == 'scheduled' && appointment.archiveList != null">
                        <span
                          class="double-camera"
                          :class="{
                            'double-green': appointment.id == mainActiveArchiveId
                          }"
                          >{{ appointment.archiveList != null && appointment.archiveList.length > 1 ? appointment.archiveList.length : "" }}</span
                        >
                      </span>
                      <b-popover v-if="appointment.id && appointment.type.toLowerCase() == 'scheduled'" :ref="'element' + appointment.id" :target="appointment.id" triggers="click blur">
                        <template v-slot:content>
                          <div @click="openRecording($event, appointment, archive, 'element' + appointment.id, index)" class="popover-camera-content" v-for="(archive, index) in appointment.archiveList" :key="index">
                            <div class="open-recording mr-10">
                              {{ new Date(archive.startTime) | formatUTCDate }}
                            </div>
                            <span
                              class="blue-camera"
                              :class="{
                                'single-green': archive.archiveId == activeArchiveId
                              }"
                            ></span>
                          </div>
                        </template>
                      </b-popover>
                      <b-popover v-if="appointment.id && appointment.type != 'Scheduled'" :ref="'element' + appointment.id" :target="appointment.id" triggers="click blur">
                        <template v-slot:content>
                          <div @click="openRecording($event, appointment, archive, 'element' + appointment.id, index)" class="popover-camera-content" v-for="(archive, index) in appointment.archiveList" :key="index">
                            <div class="open-recording mr-10">
                              {{ new Date(archive.startTime) | formatUTCDate }}
                            </div>
                            <span
                              class="blue-camera"
                              :class="{
                                'single-green': archive.archiveId == activeArchiveId
                              }"
                            ></span>
                          </div>
                        </template>
                      </b-popover>
                    </span>
                    <!-- else show simple form of camera -->
                    <span v-else>
                      <span v-if="appointment.archiveList && appointment.archiveList.length == 1 && (appointment.type.toLowerCase() == 'unscheduled' || appointment.type.toLowerCase() == 'scheduled')" @click="openRecording($event, appointment, appointment.archiveList[0])" class="camera">
                        <span
                          class="single-camera"
                          :class="{
                            'single-green': appointment.id == mainActiveArchiveId
                          }"
                        ></span>
                      </span>
                    </span>
                  </td>
                  <td>
                    {{ appointment.participantId ? appointment.participantId : "None" }}
                  </td>
                  <td>
                    <span v-if="isEligibleForPPR">
                      <router-link
                        :to="{
                          name: 'participant-profile',
                          params: { participantId: appointment.threadID }
                        }"
                        >{{ appointment.threadID }}</router-link
                      >
                    </span>
                    <span v-else>
                      <router-link
                        :to="{
                          name: 'study-participant-details',
                          params: { participantId: appointment.threadID }
                        }"
                        >{{ appointment.threadID }}</router-link
                      >
                    </span>
                  </td>
                  <td>{{ appointment.date }} {{ appointment.time }} UTC</td>
                  <td>
                    <span v-if="canUpdateAppointmentStatus() && (appointment.visitType.toLowerCase() == 'in-person' || appointment.visitType.toLowerCase() == 'homevisit' || appointment.visitType.toLowerCase() == 'phonecall')" class="inperson-status-dropdown align-self-center">
                      <select :disabled="user.readOnly === true || (appointment.status === 'Cancelled' && appointment.configFor === 'site')" v-model="appointment.status" @change="updateAppointmentStatus(appointment.id, appointment.status)">
                        <option value="NotStarted" disabled>Scheduled</option>
                        <option value="Cancelled" disabled>Cancelled</option>
                        <option value="Complete">Complete</option>
                        <option value="Missed">Missed</option>
                      </select>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- Pagination starts-->
            <div class="pagination-position" v-if="appointmentList.length">
              <div class="row display-inline-flex">
                <div @click="prevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage <= 1 }">
                  <i class="fa fa-angle-left fs-23 pt-3"></i>
                </div>
                <div class="pagination pt-3">{{ currentPage || 1 }}</div>
                <div class="pagination2 pt-3">of {{ totalPages || 1 }}</div>
                <div @click="nextPage" class="arrow-icon pt-3 cursor_pointer" :class="{ disabledPagination: currentPage >= totalPages }">
                  <i class="fa fa-angle-right fs-23"></i>
                </div>
              </div>
            </div>
            <!-- Pagination ends-->
          </div>
        </div>
      </div>
    </div>

    <participantsModal ref="participantsModal"></participantsModal>
    <b-modal ref="VisitsListsHomePhonecallDataViewModal" id="visits-lists-home-phonecall-data-view-modal" no-close-on-backdrop hide-footer hide-header body-class="modal-body-custom pt-0">
      <div class="clearfix"></div>
      <div class="activityNameLayout">
        <b
          ><p class="fs-16 pl-10 pr-10">{{ visitTypeDetails.name }}<br /></p
        ></b>
      </div>
      <div class="clearfix"></div>
      <div>
        <b-row class="rowDiv pt-10 pb-10">
          <b-col cols="4">
            <div class="subHeading pb-5">Participant ID</div>
            <div style="word-break:break-all;">
              <Span v-if="visitTypeDetails.participantId">{{ visitTypeDetails.participantId }}</Span>
              <Span v-else>NA</Span>
            </div>
          </b-col>
          <b-col cols="8">
            <div class="subHeading pb-5">THREAD ID</div>
            <div>{{ visitTypeDetails.threadId }}</div>
          </b-col>
        </b-row>
      </div>
      <div v-if="visitTypeDetails.visitType === 'homevisit'">
        <div class="mt-20">
          <span class="evaluateAddressField">Visit Address </span>
        </div>
        <div class="w-200">
          <span class="evaluateModalPhnoField">
            {{ showVisitAddress(visitTypeDetails.details) }}
          </span>
        </div>
      </div>
      <div v-if="visitTypeDetails.visitType === 'phonecall'">
        <div class="mt-20">
          <span class="evaluateAddressField">Phone Number</span>
        </div>
        <div class="w-200">
          <span class="evaluateModalPhnoField">
            <span v-if="visitTypeDetails.details.countryCode">{{ visitTypeDetails.details.countryCode }}</span>
            <span v-if="visitTypeDetails.details.phoneNumber"> {{ visitTypeDetails.details.phoneNumber }}</span>
          </span>
        </div>
      </div>
      <div class="mt-10" style="float:right;">
        <div style="display:flex;">
          <span class="cancelText mr-20 mt-5" @click="closeScreen()">Cancel</span>
          <button v-if="appointmentDetails.configFor === 'site'" @click="editVisit()" class="btn btn-primary" :disabled="editVisitBtnDisabled">
            <span class="fs-13" @click="editVisit()">Edit Visit</span>
          </button>
        </div>
      </div>
    </b-modal>
    <ScheduleVisitSiteTeam
      v-if="showScheduleVisit"
      modalType="postScheduleVisit"
      :mapVisitsData="mapVisitsData"
      :participantInfo="participantInfo"
      :visitConfiguredDetails="visitConfiguredDetails"
      :appointmentDetails="appointmentDetails"
      :piDetails="piDetails"
      :studyId="studyId"
      :siteTeamSelectedTaskDetails="siteTeamSelectedTaskDetails"
      :siteDetailsInfo="siteDetailsInfo"
      @scheduledVisitData="getConfiguredVisitData"
      @cancelEvent="cancelModal()"
      @cancelVisitEvent="cancelVisitDataEvent"
    />
  </div>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import toastr from "toastr";
import nprogress from "nprogress";
import { AclRule } from "vue-acl";
import { mapGetters } from "vuex";
import { PI, SUB_PI, STUDY_COORDINATOR, SITEDATALOCK, RATER, INTERVIEWER, HOME_HEALTH, CC } from "@/constants/authRoles";
import participantsModal from "./participants-modal";
import ScheduleVisitSiteTeam from "../participants/telehealth/schedule-visit-siteteam.vue";
import * as commonHelper from "@/components/services/common-helper";

export default {
  name: "tele-health-appointments-new",
  components: { participantsModal, ScheduleVisitSiteTeam },
  data() {
    return {
      studyId: this.$route.params.studyId,
      visitType: "",
      visitTypeList: [],
      appointmentList: [],
      searchTerm: "",
      filterVisitType: "",
      selectedShowOption: 15,
      activeArchiveId: null,
      mainActiveArchiveId: null,
      currentPage: 1,
      totalPages: 1,
      DataTableListOptions: [
        {
          value: 15,
          text: "Show 15 items"
        },
        {
          value: 50,
          text: "Show 50 items"
        },
        {
          value: 100,
          text: "Show 100 items"
        }
      ],
      lastUpdated: moment(),
      lastUpdateTime: "just now",
      lastUpdatedInterval: null,
      appointmentListRefreshInterval: null,
      responseListMsg: "Loading...",
      weekStartDate: moment()
        .utc()
        .startOf("week"),
      WeekEndDate: moment()
        .utc()
        .endOf("week"),
      isLoadingAppointment: false,
      isCurrentWeek: true,
      appointmentListResponse: null,
      isEligibleForPPR: true,
      visitTypeDetails: {},
      showScheduleVisit: false,
      siteTeamSelectedTaskDetails: {},
      mapVisitsData: {},
      participantInfo: {},
      piDetails: {},
      appointmentDetails: {},
      editVisitBtnDisabled: false,
      visitConfiguredDetails: {},
      siteDetailsInfo: {},
      isVisitsConfiguredInStudy: null,
      appointmentFilterData: {},
      getCallDone: false,
      isCallBtnDisabled: false // To handled team member's state if it has joined the call in which it is invited.
    };
  },
  watch: {
    getVideoCallStatus(isCallInProgress) {
      const self = this;
      if (isCallInProgress) {
        if (self.isCurrentWeek) {
          self.scrollToAppointment();
        } else {
          self.displayCurrentWeek();
        }
      }
    }
  },
  created() {
    this.calculateLastUpdated();
    this.isVisitConfiguredInStudy();
  },
  mounted() {
    //Load all the appointments from backend
    this.getAppointments();
    this.getToggledFeatures();

    //Look for the publisher/PI event has started call and reload the appointments
    this.$root.$on("publisherStreamStarted", () => {
      this.getAppointments();
    });
    this.$root.$on("scheduledVideoCallingInitiated", data => {
      this.startVideoCall(data);
    });
    this.$root.$on("videoCallEnded", () => {
      this.isCallBtnDisabled = false;
    });
    this.$root.$on("videoCallCancelled", () => {
      this.isCallBtnDisabled = false;
    });

    //Look for the end call event and reload the appointments
    const self = this;
    this.$root.$on("videoCallEnded", () => {
      setTimeout(() => {
        self.getAppointments();
      }, 100);
    });

    //Reload appointments every 90 seconds
    this.appointmentListRefreshInterval = window.setInterval(() => {
      this.getAppointments();
    }, 90000);

    // Play Recording
    this.$root.$on("playBackVideoEnded", () => {
      this.mainActiveArchiveId = null;
      this.activeArchiveId = null;
      this.$root.recordingPage = { pageName: null };
    });
    this.$root.$on("switchVideo", archive => {
      this.activeArchiveId = archive.archiveId;
    });
  },
  computed: {
    ...mapGetters(["user", "getVideoCallStatus"]),
    weekDateString() {
      const wsd = this.weekStartDate.format("DD MMM");
      const wsy = this.weekStartDate.format("YYYY");
      const wed = this.WeekEndDate.format("DD MMM");
      const wy = this.WeekEndDate.format("YYYY");

      return `${wsd} ${wsy} - ${wed} ${wy}`;
    },
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPiAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canScAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    },
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canCallCenterAccess() {
      this.$acl.change(`${CC}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canRaterAccess() {
      this.$acl.change(`${RATER}`);
      return this.$acl.check("userAccess");
    },
    isSiteTeamAccess() {
      return this.canHomeHealthAccess || this.canCallCenterAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.canInterviewerAccess || this.canRaterAccess;
    }
  },
  beforeDestroy() {
    clearInterval(this.lastUpdatedInterval);
    clearInterval(this.appointmentListRefreshInterval);
  },
  methods: {
    getToggledFeatures() {
      const toggleFeatures = this.$store.getters.getStudyToggledFeatures ? this.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
      toggleFeatures.forEach(feature => {
        if (feature.featureKey === "OLDPROFILEVIEW") {
          this.isEligibleForPPR = !feature.enabled;
        }
      });
    },
    filterAppointments() {
      this.getAppointments();
    },
    // change the previous page number and update the participants list
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        if (this.getCallDone) {
          this.currentPage -= 1;
          this.getAppointments();
        }
      }
    },
    // change the next page number and update the participants list
    nextPage() {
      if (this.currentPage < this.totalPages) {
        if (this.getCallDone) {
          this.currentPage += 1;
          this.getAppointments();
        }
      }
    },
    rolesAccessPermission() {
      return this.canPiAccess || this.canSubPiAccess || this.canStudyCoordinatorAccess || this.canHomeHealthAccess || this.canSiteDataLockAccess || this.canInterviewerAccess || this.canCallCenterAccess;
    },
    calculateLastUpdated() {
      this.lastUpdatedInterval = setInterval(() => {
        const currentTime = moment().utc();
        const timeDiffInSec = currentTime.diff(this.lastUpdated, "seconds");
        if (timeDiffInSec <= 0) {
          this.lastUpdateTime = "just now";
        } else if (timeDiffInSec >= 60) {
          this.lastUpdateTime = "a minute ago";
        } else {
          this.lastUpdateTime = timeDiffInSec + " sec ago";
        }
      }, 3000);
    },
    showJoinCallBtn: function(appnt) {
      const now = moment();
      const apdate = moment(appnt.startTime);
      const appointmentEndtime = moment(appnt.endTime);
      //Do not show join call for past dates,compare it with call end duration
      if (appointmentEndtime.isBefore(now)) {
        return false;
      }

      const td = apdate.diff(now, "minutes", true);

      return td <= 5;
    },
    getAppointments() {
      const self = this;
      this.getCallDone = false; //pagination will not work while requesting API

      const pId = this.user.id;

      const st = this.weekStartDate.format("DD MMM YYYY hh:mm A");
      const ed = this.WeekEndDate.format("DD MMM YYYY hh:mm A");

      const weekFrom = moment(st, "DD MMM YYYY hh:mm A").utc();
      const weekTo = moment(ed, "DD MMM YYYY hh:mm A").utc();
      let siteId = "";
      if (this.user.userRole == "Interviewer") {
        siteId = localStorage.getItem("selectedSite").toString();
      } else {
        siteId = this.user.siteIds ? this.user.siteIds[0] : null;
      }

      //For getting all the appointments
      let isUserRole = false;
      if (this.user.userRole == "Interviewer") {
        isUserRole = true;
      }

      this.$api
        .getVisitsAppointmentList({
          siteId: siteId,
          pId: pId,
          startDate: weekFrom.valueOf(),
          endDate: weekTo.valueOf(),
          search: this.searchTerm,
          studyId: this.studyId,
          isUserRole: isUserRole,
          filter: this.filterVisitType,
          sortOrder: this.sortOrder,
          sortValue: this.sortValue,
          pageSize: this.selectedShowOption,
          pageNum: this.currentPage
        })
        .then(
          response => {
            self.isLoadingAppointment = false;
            self.appointmentList = [];
            self.lastUpdated = moment();
            const responseObj = response.body.participants;
            if (responseObj.length == 0) {
              self.responseListMsg = "No appointments.";
              return;
            }

            self.appointmentListResponse = responseObj;

            //pagination handling here
            this.getCallDone = true; // pagination enabled after API response
            this.totalPages = response.body.totalPages;
            this.currentPage = response.body.currentPage;

            _.forEach(responseObj, function(element) {
              let appointmentDateObj = null;
              if (element.type == "Scheduled") {
                appointmentDateObj = moment(element.startTime);
              } else if (element.type == "Unscheduled") {
                appointmentDateObj = moment(element.appointmentDate);
              }

              const appointmentDatestr = appointmentDateObj.utc().format("DD MMM YYYY");
              const threadIDStr = element.participantId;
              const participantIDStr = element.userDefineParticipantId;
              // show the playback icon only when a recording is available, and filter recording order
              const archiveList = commonHelper.filterArchiveList(element.archiveList);
              const appointmentNameStr = element.visitName ? element.visitName : element.type;

              let isRescheduledAppointment = false;
              const appointmentTimeStr = appointmentDateObj.utc().format("hh:mm A");
              let statusStr = element.status;
              statusStr = statusStr.replace(/ /g, "");
              if (statusStr == "NotStarted" && element.visitType.toLowerCase() == "telehealth") {
                // So the list refresh every 90 sec and if the appointment duration(End Time) has passed and the list is not refreshed with latest status then show the missed status from Web UI
                const appointmentEndTimeObj = moment(element.endTime);
                statusStr = appointmentEndTimeObj.isBefore(moment()) ? "Missed" : statusStr;
              } else if (statusStr.toLowerCase() == "reschedule") {
                isRescheduledAppointment = true;
                statusStr = "Cancelled";
              } else if (statusStr.toLowerCase() == "sitecancelled") {
                statusStr = "Cancelled";
              }

              let participantAppointmentContact = {};
              if (element.participantAppointmentContact) {
                participantAppointmentContact = element.participantAppointmentContact;
              }
              const configFor = element.configFor ? element.configFor : "participant";

              // Update visit types for each week
              if (!self.visitTypeList.find(vtype => vtype === element.visitType)) {
                self.visitTypeList.push(element.visitType);
              }

              const appointmentDetailObject = {
                threadID: threadIDStr,
                participantId: participantIDStr,
                name: appointmentNameStr,
                time: appointmentTimeStr,
                status: statusStr,
                type: element.type.toLowerCase(),
                appDateTime: element.appointmentDate,
                id: element.id,
                visitId: element.visitId,
                startTime: element.startTime,
                endTime: element.endTime,
                isRescheduled: isRescheduledAppointment,
                visitType: element.visitType,
                participantAppointmentContact: participantAppointmentContact,
                configFor: configFor,
                date: appointmentDatestr,
                archiveList: archiveList,
                invitedInTelehealthVisit: false,
                piId: element.piId
              };

              self.appointmentList.push(appointmentDetailObject);
            });

            let appointmentNotStarted_id = "";
            let appointmentInProgress_id = "";
            self.appointmentList.find(appointment => {
              if (appointment.status == "NotStarted") {
                appointmentNotStarted_id = appointment.id;
              }
              if (appointment.status == "InProgress" || appointment.status == "In Progress") {
                appointmentInProgress_id = appointment.id;
              }
            });
            const appointment_id = appointmentInProgress_id || appointmentNotStarted_id;
            if (appointment_id) {
              this.$api.getResearchTeamMembersFact(this.studyId, siteId, appointment_id).then(
                response => {
                  const teamMember = response.body;
                  _.forEach(self.appointmentList, function(list, index) {
                    _.forEach(teamMember, function(member) {
                      if (member.id == pId && (list.status == "InProgress" || list.status == "In Progress" || list.status == "NotStarted")) {
                        self.appointmentList[index].invitedInTelehealthVisit = member.invitedInTelehealthVisit;
                      }
                      if (list.status == "NotStarted" && list.piId == pId) {
                        self.appointmentList[index].invitedInTelehealthVisit = true;
                      }
                    });
                  });
                },
                error => {
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting research team members.");
                }
              );
            }
            self.$nextTick(function() {
              // DOM updated
              self.scrollToAppointment();
            });
          },
          error => {
            self.isLoadingAppointment = false;
            const errMsg = "Error while getting the appointment list!";
            self.responseListMsg = errMsg;
            toastr.error(error.body && error.body.message ? error.body.message : errMsg);
          }
        );
    },
    showParticipantModal() {
      this.$refs.participantsModal.show();
    },
    displayCurrentWeek() {
      this.weekStartDate = moment()
        .utc()
        .startOf("week");
      this.WeekEndDate = moment()
        .utc()
        .endOf("week");
      //Load the Appointments
      this.isCurrentWeek = true;
      this.getAppointments();
    },
    previousWeekList() {
      this.isCurrentWeek = false;
      this.isLoadingAppointment = true;
      this.visitTypeList = [];

      const pw = this.weekStartDate.subtract(1, "days");

      this.weekStartDate = moment(pw)
        .utc()
        .startOf("week");
      this.WeekEndDate = moment(pw)
        .utc()
        .endOf("week");

      //Load the appointments
      this.getAppointments();
    },
    nextWeekList() {
      this.isCurrentWeek = false;
      this.isLoadingAppointment = true;
      this.visitTypeList = [];

      const nw = this.WeekEndDate.add(1, "days");

      this.weekStartDate = moment(nw)
        .utc()
        .startOf("week");
      this.WeekEndDate = moment(nw)
        .utc()
        .endOf("week");

      //Load the appointments
      this.getAppointments();
    },
    startVideoCall(appointmentObject) {
      appointmentObject.studyId = this.studyId;
      this.$api.getParticipantDataFactV2(this.studyId, appointmentObject.threadID).then(
        response => {
          appointmentObject.countryId = response.body.countryId;
          this.$root.$emit("videoCallingInitiated", appointmentObject);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    scrollToAppointment() {
      if (this.isCurrentWeek) {
        const ccId = window.localStorage.getItem("thread-currentCallId");
        if (ccId) {
          const element = document.getElementById(ccId);
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest"
            });

            //set the Appointment id of the call being in progress in local storage
            localStorage.setItem("thread-inProgressCallId", ccId);

            localStorage.removeItem("thread-currentCallId");
          }
        }
      }
    },
    getInProgressCallId() {
      return localStorage.getItem("thread-inProgressCallId");
    },
    hasCallTimePassed(appnt) {
      const now = moment();
      const appointmentEndtime = moment(appnt.endTime);
      //Do not show join call for past dates,compare it with call end duration
      if (appointmentEndtime.isBefore(now)) {
        return true;
      } else {
        return false;
      }
    },
    updateAppointmentStatus(appointmentId, status) {
      let appointmentObj = _.filter(this.appointmentListResponse, ["id", appointmentId]);
      appointmentObj = appointmentObj[0];
      appointmentObj.status = status;
      this.$api.updateTelehealthAppointmentStatus(appointmentObj).then(
        () => {},
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error occurred while updating the status.");
        }
      );
    },
    initateVideoCall(appointmentDetailObject) {
      let countryId = "";
      this.$api.getParticipantDataFactV2(this.studyId, appointmentDetailObject.threadID).then(
        response => {
          countryId = response.body.countryId;
          this.isCallBtnDisabled = true;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
      //Emit an event to show/start the video call component
      this.$root.$emit("videoCallStarted", {
        participantId: appointmentDetailObject.participantId,
        countryId: countryId,
        studyId: this.studyId,
        deviceRegistrationStatus: true,
        appointmentType: appointmentDetailObject.type,
        appointmentObject: appointmentDetailObject
      });
    },
    canUpdateAppointmentStatus() {
      return this.canPiAccess || this.canSubPiAccess || this.canScAccess || this.canInterviewerAccess;
    },
    showPhoneVisitDetails(record) {
      this.siteTeamSelectedTaskDetails = record;
      this.visitTypeDetails = {
        visitType: record.visitType.toLowerCase(),
        threadId: record.threadID,
        participantId: record.participantId,
        name: record.name,
        details: record.participantAppointmentContact
      };
      const getAppointmentDetails = this.appointmentListResponse.filter(data => data.id === this.siteTeamSelectedTaskDetails.id);
      this.appointmentDetails = getAppointmentDetails[0];
      this.siteTeamSelectedTaskDetails.taskId = this.appointmentDetails.visitId;
      this.siteTeamSelectedTaskDetails.taskInstanceId = this.appointmentDetails.taskInstanceUUID;
      this.editVisitBtnDisabled = false;
      const getCurrentStatus = record.status.toLowerCase();
      if (getCurrentStatus === "cancelled" || getCurrentStatus === "complete" || getCurrentStatus === "missed" || record.isRescheduled || this.appointmentDetails.startTime < new Date().getTime()) {
        this.editVisitBtnDisabled = true;
      }
      this.getParticipantInfoDetails(this.$route.params.studyId, record.threadID, getAppointmentDetails[0]);
      if (record.visitType === "Phonecall" || record.visitType === "Homevisit") {
        this.$api.getContactDetailsFact(record.id, record.threadID).then(response => {
          if (response.body) {
            this.visitTypeDetails.details = response.body;
            this.appointmentDetails.participantAppointmentContact = response.body;
            const checkCountryCodeplus = this.visitTypeDetails.details.countryCode.toString();
            if (checkCountryCodeplus.includes("+") === false) {
              this.visitTypeDetails.details.countryCode = `+${this.visitTypeDetails.details.countryCode}`;
            }
            this.$refs.VisitsListsHomePhonecallDataViewModal.show();
          }
        });
      } else {
        this.$refs.VisitsListsHomePhonecallDataViewModal.show();
      }
    },
    addVisitTypeIcon(visitType) {
      if (visitType === "Telehealth") {
        return "icon-video-call";
      } else if (visitType === "In-person") {
        return "icon-office-visit";
      } else if (visitType === "Homevisit") {
        return "icon-home-visit";
      } else if (visitType === "Phonecall") {
        return "icon-phone-call";
      } else {
        return visitType;
      }
    },
    showVisitTypeDesc(visitType) {
      if (visitType === "Telehealth") {
        return "Video Call";
      } else if (visitType === "In-person") {
        return "Office Visit";
      } else if (visitType === "Homevisit") {
        return "Home Visit";
      } else if (visitType === "Phonecall") {
        return "Phone Call";
      } else {
        return visitType;
      }
    },
    showVisitStatusDesc(appointment) {
      if (appointment.status.toLowerCase() === "notstarted") {
        return moment(appointment.endTime).isBefore(moment()) ? "Missed" : "";
      } else if (appointment.isRescheduled && appointment.status.toLowerCase() === "cancelled") {
        return "Rescheduled";
      } else if (appointment.status.toLowerCase() === "sitecancelled" || appointment.status.toLowerCase() === "cancelled") {
        return "Cancelled";
      } else {
        return appointment.status;
      }
    },
    closeScreen() {
      this.$refs.VisitsListsHomePhonecallDataViewModal.hide();
    },
    editVisit() {
      if (!this.editVisitBtnDisabled && (this.canPiAccess || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth")) {
        this.getVisitConfigDetails(this.$route.params.studyId, this.siteTeamSelectedTaskDetails);
      }
    },
    getConfiguredVisitData(data) {
      if (this.checkforRescheduleFlag(data)) {
        this.$api.reScheduleAppointmentParticipantFact(this.siteTeamSelectedTaskDetails.id, data).then(
          response => {
            if (response.body) {
              this.$toastr.success("Visit rescheduled successfully");
              this.showScheduleVisit = false;
              this.getAppointments();
            }
          },
          err => {
            this.showScheduleVisit = false;
            this.$toastr.error(err.body.message);
          }
        );
      } else {
        const updateObj = {
          address: data.participantAppointmentContact ? data.participantAppointmentContact.address : "",
          city: data.participantAppointmentContact ? data.participantAppointmentContact.city : "",
          state: data.participantAppointmentContact ? data.participantAppointmentContact.state : "",
          country: data.participantAppointmentContact ? data.participantAppointmentContact.country : "",
          zipcode: data.participantAppointmentContact ? data.participantAppointmentContact.zipcode : "",
          countryCode: data.participantAppointmentContact ? data.participantAppointmentContact.countryCode : "",
          phoneNumber: data.participantAppointmentContact ? data.participantAppointmentContact.phoneNumber : "",
          smsCountryIsoName: data.participantAppointmentContact ? data.participantAppointmentContact.smsCountryIsoName : "",
          visitNote: data.visitNote
        };
        this.$api.updateVisitAppointmentFact(this.$route.params.studyId, this.participantInfo.siteId, this.siteTeamSelectedTaskDetails.id, this.siteTeamSelectedTaskDetails.threadID, updateObj).then(
          response => {
            if (response.body) {
              this.$toastr.success("Visit Appointment updated successfully");
              this.showScheduleVisit = false;
            }
          },
          err => {
            this.showScheduleVisit = false;
            this.$toastr.error(err.body.message);
          }
        );
      }
    },
    cancelModal() {
      this.showScheduleVisit = false;
    },
    showVisitAddress(details) {
      let formString = "";
      if (details.address != "") {
        formString = details.address;
      }
      if (details.city != "") {
        formString = formString + ", " + details.city;
      }
      if (details.state != "") {
        formString = formString + ", " + details.state;
      }
      if (details.country != "") {
        formString = formString + ", " + details.country;
      }
      if (details.zipcode != "") {
        formString = formString + ", " + details.zipcode;
      }
      return formString;
    },
    getVisitConfigDetails(studyId, record) {
      this.$api.getVisitDetail(studyId, record.visitId).then(
        response => {
          const getVisitTypes = response.body.telehealthVisitDTO.visitType;
          const visitSplitData = getVisitTypes.split("|");
          const visitsDataObject = [];
          for (let i = 0; i < visitSplitData.length; i++) {
            if (visitSplitData[i] === "Telehealth") {
              visitsDataObject.push({
                name: "Video Call",
                logoUrl: "static/img/telehealth/video-call-icon.svg",
                selected: false
              });
            } else if (visitSplitData[i] === "In-person") {
              visitsDataObject.push({
                name: "Office Visit",
                logoUrl: "static/img/telehealth/office-visit-icon.svg",
                selected: false
              });
            } else if (visitSplitData[i] === "Homevisit") {
              visitsDataObject.push({
                name: "Home Visit",
                logoUrl: "static/img/telehealth/home-visit-icon.svg",
                selected: false
              });
            } else if (visitSplitData[i] === "Phonecall") {
              visitsDataObject.push({
                name: "Phone Call",
                selected: false,
                logoUrl: "static/img/telehealth/phone-call-icon.svg"
              });
            }
          }
          this.mapVisitsData.scheduleVisitType = visitsDataObject;
          this.visitConfiguredDetails = response.body;
          this.callVisitDetails(record);
        },
        error => {
          this.$toastr.error(error.body ? error.body.message : "Error while fetching telehealth visits");
          nprogress.done();
        }
      );
    },
    getParticipantInfoDetails(studyId, threadID, appointmentDetails) {
      this.$api.getParticipantDataFactV2(studyId, threadID).then(
        response => {
          this.participantInfo = response.body;
          this.getPIInfoDetails(studyId, this.participantInfo.siteId);
          this.getStudyDetails();
          this.$api.getVisitAppoitmentFact(studyId, this.participantInfo.siteId, appointmentDetails.id, appointmentDetails.participantId).then(
            response => {
              if (response.body) {
                this.appointmentDetails = response.body;
                if (this.appointmentDetails.status.toLowerCase().trim() === "sitecancelled") {
                  this.editVisitBtnDisabled = true;
                }
              }
            },
            err => {
              this.$toastr.error(err.body.message);
            }
          );
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participant.");
        }
      );
    },
    async getPIInfoDetails(studyId, siteId) {
      let getPI_ID = "";
      const getDataList = await this.$api.getPI_ID(studyId, siteId);
      getPI_ID = getDataList.body.filter(data => {
        return data.userRole === "Pi";
      });
      this.piDetails = getPI_ID[0];
    },
    async callVisitDetails(record) {
      const getAppointmentDetails = this.appointmentListResponse.filter(data => data.id === record.id);
      const getSlotsData = await this.$api.getTelehealthVisitSlotsFact(this.$route.params.studyId, this.participantInfo.siteId, record.threadID, getAppointmentDetails[0].visitId, getAppointmentDetails[0].taskInstanceUUID, this.getLocalOffset(), this.getLocalTimeZone());
      this.processSlotsDateTime(getSlotsData.body);
    },
    processSlotsDateTime(slotsList) {
      const getDates = Object.keys(slotsList);
      const getTimeValues = [];
      this.mapVisitsData.dateTotalValues = [];
      for (let i = 0; i < getDates.length; i++) {
        const dateObject = {
          selected: false,
          dateValue: parseInt(getDates[i]),
          index: i
        };
        this.mapVisitsData.dateTotalValues.push(dateObject);
        const timeValuesObject = {
          [getDates[i]]: slotsList[getDates[i]]
        };
        getTimeValues.push(timeValuesObject);
      }
      this.mapVisitsData.timeTotalValues = [];
      for (let j = 0; j < getDates.length; j++) {
        this.formatTimeValues(getDates[j], getTimeValues);
      }
      this.prefillAppointmentData();
    },
    formatTimeValues(dateValue, getTimeValues) {
      const getfilteredTimeValues = getTimeValues.filter(data => {
        return data[dateValue];
      });
      const timesValues = Object.keys(getfilteredTimeValues[0][dateValue]);
      for (let j = 0; j < timesValues.length; j++) {
        const obj = getfilteredTimeValues[0][dateValue][timesValues[j]];
        obj.selected = false;
        obj.dateValue = getfilteredTimeValues[0][dateValue][timesValues[j]].slotStartTime;
        obj.currentDate = parseInt(dateValue);
        this.mapVisitsData.timeTotalValues.push(obj);
      }
    },
    getLocalOffset() {
      const offset = new Date().getTimezoneOffset();
      const o = Math.abs(offset);
      return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    },
    prefillAppointmentData() {
      const getAppointmentDetails = this.appointmentListResponse.filter(data => data.id === this.siteTeamSelectedTaskDetails.id);
      this.$api.getVisitAppoitmentFact(this.$route.params.studyId, this.participantInfo.siteId, getAppointmentDetails[0].id, getAppointmentDetails[0].participantId).then(
        response => {
          if (response.body) {
            this.appointmentDetails = response.body;
            if (this.appointmentDetails.status.toLowerCase().trim() === "sitecancelled") {
              this.editVisitBtnDisabled = true;
            }
          }
        },
        err => {
          this.$toastr.error(err.body.message);
        }
      );
      let getVisitType = getAppointmentDetails[0].visitType;
      switch (getVisitType) {
        case "Homevisit":
          getVisitType = "Home Visit";
          break;
        case "Telehealth":
          getVisitType = "Video Call";
          break;
        case "In-person":
          getVisitType = "Office Visit";
          break;
        case "Phonecall":
          getVisitType = "Phone Call";
          break;
      }
      const getSelectedVisitTypeIndex = this.mapVisitsData.scheduleVisitType.findIndex(obj => obj.name === getVisitType);
      const self = this;
      const getvisitsDateSlots = JSON.parse(JSON.stringify(this.mapVisitsData.dateTotalValues));
      const uniqueVisitDatesSlots = [];
      getvisitsDateSlots.push({
        dateValue: self.appointmentDetails.startTime,
        index: this.mapVisitsData.dateTotalValues.length - 1,
        selected: false
      });
      for (let m = 0; m < getvisitsDateSlots.length; m++) {
        if (uniqueVisitDatesSlots.length === 0) {
          uniqueVisitDatesSlots.push({
            dateValue: getvisitsDateSlots[m].dateValue,
            index: 0,
            selected: false
          });
        } else {
          const getDuplicateCheckCount = uniqueVisitDatesSlots.findIndex(v => {
            return new Date(v.dateValue).toLocaleDateString() === new Date(getvisitsDateSlots[m].dateValue).toLocaleDateString();
          });
          if (getDuplicateCheckCount === -1) {
            uniqueVisitDatesSlots.push({
              dateValue: getvisitsDateSlots[m].dateValue,
              index: uniqueVisitDatesSlots.length + 1,
              selected: false
            });
          }
        }
      }
      this.mapVisitsData.dateTotalValues = uniqueVisitDatesSlots;
      const getSelectedDateVisitTypeIndex = this.mapVisitsData.dateTotalValues.findIndex(dateObj => {
        return new Date(dateObj.dateValue).toLocaleDateString() === new Date(self.siteTeamSelectedTaskDetails.startTime).toLocaleDateString();
      });
      const getSavedDateFormatVisitStringValue = new Date(self.siteTeamSelectedTaskDetails.startTime).toLocaleDateString().split("/");
      const saveTimeObj = {
        appointmentSlotId: getAppointmentDetails[0].piAvailabilitySlot,
        availabilityId: getAppointmentDetails[0].piAvailabilityId,
        currentDate: getAppointmentDetails[0].startTime,
        dateString: getSavedDateFormatVisitStringValue[2] + "-" + getSavedDateFormatVisitStringValue[0] + "-" + getSavedDateFormatVisitStringValue[1],
        dateValue: getAppointmentDetails[0].startTime,
        extendWindowSlot: this.visitConfiguredDetails.telehealthVisitDTO.extendAvailability,
        selected: null,
        siteId: getAppointmentDetails[0].siteId,
        slotDate: getAppointmentDetails[0].startTime,
        slotEndTime: getAppointmentDetails[0].endTime,
        slotStartTime: getAppointmentDetails[0].startTime,
        timeZone: this.getLocalOffset()
      };
      this.mapVisitsData.timeTotalValues.push(saveTimeObj);
      this.mapVisitsData.scheduleVisitType[getSelectedVisitTypeIndex].selected = true;
      this.mapVisitsData.dateTotalValues[getSelectedDateVisitTypeIndex].selected = null;
      const selectedDateTimeLists = this.mapVisitsData.timeTotalValues.filter(dateTimeObj => {
        return new Date(dateTimeObj.dateValue).toLocaleDateString() === new Date(getAppointmentDetails[0].startTime).toLocaleDateString();
      });
      this.mapVisitsData.selectedDateTimeLists = selectedDateTimeLists;
      this.$refs.VisitsListsHomePhonecallDataViewModal.hide();
      this.showScheduleVisit = true;
    },
    checkforRescheduleFlag(dataObj) {
      let rescheduleFlag = false;
      if (dataObj.visitType != this.appointmentDetails.visitType) {
        rescheduleFlag = true;
      } else if (dataObj.piAvailabilitySlot != this.appointmentDetails.piAvailabilitySlot) {
        rescheduleFlag = true;
      } else if (dataObj.piAvailabilityId != this.appointmentDetails.piAvailabilityId) {
        rescheduleFlag = true;
      }
      return rescheduleFlag;
    },
    getStudyDetails() {
      this.$api
        .getStudyDataFact(this.$route.params.studyId)
        .then(
          response => {
            if (response.body) {
              this.siteDetailsInfo = response.body.sitesInfo.filter(data => data.id === this.participantInfo.siteId)[0];
            }
          },
          error => {
            const err = error.body && error.body.message ? error.body.message : "Error while getting the study details";
            this.$toastr.error(err);
          }
        )
        .catch(error => {
          if (error && (error.message || error.body.message)) {
            this.$toastr.error(error.message || error.body.message);
          } else {
            this.$toastr.error("Unable to fetch the study details");
          }
        });
    },
    getLocalTimeZone() {
      return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
    },
    cancelVisitDataEvent(data) {
      this.$api.deleteVisitAppointmentFact(this.$route.params.studyId, this.participantInfo.siteId, this.siteTeamSelectedTaskDetails.id, this.siteTeamSelectedTaskDetails.threadID, data).then(
        response => {
          if (response.body) {
            this.$toastr.success("Visit Appointment cancelled successfully");
            this.showScheduleVisit = false;
            this.getAppointments();
          }
        },
        err => {
          this.showScheduleVisit = false;
          this.$toastr.error(err.body.message);
        }
      );
    },
    isVisitConfiguredInStudy() {
      this.$api.getAvailabilityBtnVisibility(this.studyId).then(
        response => {
          if (response.body == true) {
            this.isVisitsConfiguredInStudy = true;
          } else {
            this.isVisitsConfiguredInStudy = false;
          }
        },
        err => {
          this.$toastr.error(err.body.message);
        }
      );
    },
    //managing sorting here
    sortList(sortValue, custom) {
      if (custom) {
        this.sortValue = "customLabel";
        this.customKey = sortValue;
      } else {
        this.sortValue = sortValue;
      }
      this.resetSortValues(sortValue);
      this.appointmentFilterData[sortValue] = _.cloneDeep(!this.appointmentFilterData[sortValue]);
      if (this.appointmentFilterData[sortValue]) {
        this.sortOrder = "asc";
      } else {
        this.sortOrder = "desc";
      }
      this.getAppointments();
    },
    resetSortValues(sortValue) {
      Object.keys(this.appointmentFilterData).forEach(key => {
        if (sortValue !== key) {
          this.appointmentFilterData[key] = "";
        }
      });
    },
    openRecording(event, record, archive, element = null, index = null) {
      event.stopPropagation();
      if (this.mainActiveArchiveId && this.mainActiveArchiveId != record.id) {
        this.$toastr.error("Another recording is currently playing.");
        return;
      }
      if (this.$root.telehealthStarted) {
        this.$toastr.error("Call is in progress. Please try later.");
        return;
      }
      this.$root.recordingPage = { pageName: "visitsTable" };
      this.activeArchiveId = archive && archive.archiveId;
      this.mainActiveArchiveId = record.id;
      this.getArchiveUrl(archive, record, element, index);
    },
    getArchiveUrl(archive, record, element, index = null) {
      this.$api.getArchiveUrl(this.studyId, archive.archiveId).then(response => {
        if (response.body) {
          const obj = {
            archiveListLength: record.archiveList.length,
            type: "fullScreen",
            archiveUrl: response.body,
            archiveId: archive.archiveId,
            telehealthName: record.name,
            recordDate: archive.startTime,
            archiveList: record.archiveList.length > 1 ? record.archiveList : null,
            archiveIndex: index + 1
          };
          // hide the popover
          if (element != null) {
            this.$refs[element][0].$emit("close");
          }
          this.$root.$emit("playBackVideoStarted", obj);
        } else {
          this.$toastr.error("Archive is not available at this point. Please try again later.");
          if (element != null) {
            this.$refs[element][0].$emit("close");
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" src="@/assets/table-styling.scss"></style>
<style scoped lang="scss">
.appointment-container {
  background-color: #ffffff;

  .link-color {
    color: #1d7fee !important;
  }

  & .search-field {
    padding: 8px !important;
    background-image: url("/static/img/search1.svg");
    background-repeat: no-repeat;
    background-position: 97% 50%;
    color: #2d3752;
    border: 1px solid #e4e8eb !important;
  }

  & .select_section {
    select.form-control {
      height: 38px !important;
      background: #ffffff !important;
      color: #4a4a4a !important;
      border: 1px solid #e4e8eb !important;
      line-height: 22px;
    }
    &:after {
      content: "\F107";
      font: normal normal normal 20px/1 FontAwesome;
      color: #1f8fe1;
      right: 25px;
      top: 10px;
      height: 34px;
      padding: 0 0 0 1px;
      /* border-left: 1px solid #0ebeff; */
      position: absolute;
      pointer-events: none;
    }
  }

  .select_control {
    background-repeat: no-repeat;
    //border: none;
  }
  .input-bg {
    background: #ffffff !important;
    color: #4a4a4a !important;
    border: 1px solid #e4e8eb !important;
  }

  .show_section:after {
    content: "\F107";
    font: normal normal normal 20px/1 FontAwesome;
    color: #1e8fe1;
    right: 10px;
    top: 8px;
    height: 34px;
    padding: 0 0 0 1px;
    position: absolute;
    pointer-events: none;
  }

  .sortDown {
    position: absolute;
    padding-left: 4px;
    padding-top: 3px;
  }

  .sortUp {
    position: absolute !important;
    margin-top: -3px;
    padding-left: 4px;
  }

  .table-striped > tbody > tr:nth-of-type(odd) {
    background-color: #f5f8fa !important;
  }

  .table {
    .heading-color {
      color: #9b9b9b !important;
      border-top: none;
      border-bottom: none;
      vertical-align: top;
    }

    tr {
      //height: 57px;
      &:last-child {
        border-bottom: 1px solid #dee2e6;
      }
    }

    th,
    td {
      line-height: 20px;
      vertical-align: middle !important;
    }
  }
  .table-border {
    border-bottom: 1px solid #e4e8eb !important;
  }

  .status {
    display: inline-block;
    border-radius: 5px;
    padding: 2px;
    font-size: 10px;
    width: 56px;
    cursor: context-menu;
    &.complete {
      color: #fff;
      background-color: #4c8ce4;
    }
    &.completed {
      color: #fff;
      background-color: #4c8ce4;
    }
    &.pending {
      background-color: #e9f1fc;
      color: #94baef;
      border: 1px solid #c7dbf6;
    }
    &.missed {
      color: #fff;
      background-color: #f16559;
    }
    &.start {
      border: 1px solid #4c8ce4;
      color: #4c8ce4;
      cursor: pointer;
      i {
        color: #4c8ce4;
        font-size: 8px;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    &.cancelled {
      background-color: #f5a623;
      color: #ffffff;
    }
    &.notstarted {
      background-color: #bfbfbf;
      color: #ffffff;
      padding: 1px 0;
    }
  }

  .pagination-position {
    padding: 10px 20px;
    border-top: 1px solid #e4e8eb;

    .arrow-icon {
      width: 32px;
      height: 32px;
      border-radius: 3px;
      background-color: #ffffff;
      border: solid 1px #e4e8eb;
      text-align: center;
      font-size: 23px;
      line-height: 10px !important;
      color: #e4e8eb;
    }

    .pagination {
      width: 32px;
      height: 32px;
      border-radius: 3px;
      background-color: #ffffff;
      border: solid 1px #e4e8eb;
      text-align: center;
      font-size: 13px;
      line-height: 23px !important;
      color: #4a4a4a;
      padding-left: 11px !important;
    }

    .pagination2 {
      width: 40px;
      height: 32px;
      background-color: #ffffff;
      font-size: 13px;
      line-height: 23px !important;
      color: #4a4a4a;
      padding-left: 6px !important;
    }

    .disabledPagination {
      pointer-events: none;
    }
  }
}

.appointments {
  font-family: Lato-Regular;
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  color: #4a4a4a;
  width: 100%;

  & .last-updated {
    font-size: 12px;
  }

  & .search-field {
    border: 1px solid #e4e8eb !important;
    height: 38px;
  }

  .visit-type-field {
    margin-right: 8px;
    display: inline-table;
    vertical-align: top;
  }

  .icon-home-visit {
    background: url("/static/img/telehealth/homeVisitLogo.svg") no-repeat center;
    height: 20px;
    width: 20px;
  }

  .icon-office-visit {
    background: url("/static/img/telehealth/InPerson_comingUp.png") no-repeat center;
    height: 20px;
    width: 20px;
  }

  .icon-phone-call {
    background: url("/static/img/telehealth/phoneCall.svg") no-repeat center;
    height: 20px;
    width: 20px;
  }

  .icon-video-call {
    background: url("/static/img/telehealth/telehealth_comingUp.png") no-repeat center;
    height: 20px;
    width: 20px;
  }

  /* Bootstrap 4 text input with search icon */

  .has-search .form-control {
    padding-left: 2.375rem;
  }

  .has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
  }

  .scroll-up {
    font-size: 12px;
    font-weight: bold;
    background-color: #f9f9fb;
    color: #b0bac9;
    padding: 8px 15px;
    border-top: 1px solid #e4e8eb;
    border-bottom: 1px solid #e4e8eb;
  }

  .paddings {
    padding: 20px;
  }

  .appointment-details {
    border-bottom: 1px solid #e4e8eb;
    padding: 15px 15px;
    position: relative;
  }

  /* fieldset .appointment-details:first-of-type {
    padding-top: 30px;
  }
*/
  fieldset .appointment-details:last-of-type {
    padding-bottom: 30px;
  }

  .appointment-details.unscheduled .appointment-name {
    color: #f0ad4e;
  }

  .status-icon {
    min-width: 4.1%;
  }

  .complete .status-icon {
    background: url("/static/img/telehealth/Telehealth_status_complete.png") no-repeat center center;
    min-height: 15px;
    width: 15px;
  }

  .cancelled .status-icon {
    background: url("/static/img/telehealth/Telehealth_status_canceled.png") no-repeat center center;
    min-height: 15px;
    width: 15px;
  }

  .missed .status-icon {
    background: url("/static/img/telehealth/Telehealth_status_missed.png") no-repeat center center;
    min-height: 15px;
    width: 15px;
  }

  .notstarted .status-icon.call-in-progress,
  .inprogress .status-icon.call-in-progress,
  .initiated .status-icon.call-in-progress {
    background: url("/static/img/telehealth/call-in-progress.png") no-repeat center;
    min-height: 5vh;
    width: 4%;
  }

  //Visit Type Icon CSS
  .visit-type-icon {
    position: absolute;
    min-width: 4%;
    top: 19px;
  }

  //---------Telehealth Visit type--------
  .telehealth-visit {
    .visit-type-icon {
      top: 17px;
    }
  }
  .notstarted.telehealth-visit .visit-type-icon,
  .inprogress.telehealth-visit .visit-type-icon,
  .initiated.telehealth-visit .visit-type-icon {
    background: url("/static/img/telehealth/telehealth_comingUp.png") no-repeat center;
    min-height: 25px;
    min-width: 4.1%;
  }

  .complete.telehealth-visit .visit-type-icon {
    background: url("/static/img/telehealth/telehealth_complete.png") no-repeat center;
    min-height: 25px;
    min-width: 4.1%;
  }

  .missed.telehealth-visit .visit-type-icon,
  .cancelled.telehealth-visit .visit-type-icon {
    background: url("/static/img/telehealth/telehealth_missed.png") no-repeat center;
    min-height: 25px;
    min-width: 4.1%;
  }
  //---------Telehealth Visit type Ends--------

  //---------Inperson Visit type--------
  .notstarted.in-person-visit .visit-type-icon,
  .inprogress.in-person-visit .visit-type-icon,
  .initiated.in-person-visit .visit-type-icon {
    background: url("/static/img/telehealth/InPerson_comingUp.png") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .complete.in-person-visit .visit-type-icon {
    background: url("/static/img/telehealth/InPerson_complete.png") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .missed.in-person-visit .visit-type-icon,
  .cancelled.in-person-visit .visit-type-icon {
    background: url("/static/img/telehealth/InPerson_missed.png") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .notstarted.in-person-visit .visit-type-icon.call-time-passed {
    background: url("/static/img/telehealth/InPerson_warning.png") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .inperson-status-dropdown {
    position: relative;
    select {
      background-image: none;
      color: #495057;
      border-radius: 3px;
      box-shadow: inset 0 1px 2px 0 #e4e8eb;
      border: solid 1px #e4e8eb;
      padding: 0.5em;
      padding-right: 1.7em;
      //position: absolute;
      right: 11%;
      top: -8px;
      width: 105px;
    }
    &:after {
      content: "\F107";
      font: normal normal normal 20px/1 FontAwesome;
      color: #1e8fe1;
      right: 7px;
      top: 0;
      height: 34px;
      padding: 0 0 0 1px;
      position: absolute;
      pointer-events: none;
    }
  }
  //---------Inperson Visit type Ends--------

  //---------Home Visit type--------
  .notstarted.homevisit-visit .visit-type-icon,
  .inprogress.homevisit-visit .visit-type-icon,
  .initiated.homevisit-visit .visit-type-icon {
    background: url("/static/img/telehealth/homeVisit_comingUp.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .complete.homevisit-visit .visit-type-icon {
    background: url("/static/img/telehealth/homeVisit_complete.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .missed.homevisit-visit .visit-type-icon,
  .cancelled.homevisit-visit .visit-type-icon {
    background: url("/static/img/telehealth/homeVisit_missed.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .notstarted.homevisit-visit .visit-type-icon.call-time-passed {
    background: url("/static/img/telehealth/homeVisit_warning.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }
  //---------Home Visit type Ends--------

  //---------Phone Call Visit type--------
  .notstarted.phonecall-visit .visit-type-icon,
  .inprogress.phonecall-visit .visit-type-icon,
  .initiated.phonecall-visit .visit-type-icon {
    background: url("/static/img/telehealth/phoneCall_comingUp.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .complete.phonecall-visit .visit-type-icon {
    background: url("/static/img/telehealth/phoneCall_complete.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .missed.phonecall-visit .visit-type-icon,
  .cancelled.phonecall-visit .visit-type-icon {
    background: url("/static/img/telehealth/phoneCall_missed.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }

  .notstarted.phonecall-visit .visit-type-icon.call-time-passed {
    background: url("/static/img/telehealth/phoneCall_warning.svg") no-repeat center;
    width: 21px;
    min-height: 21px;
  }
  //---------Phone Call Visit type Ends--------

  .complete .time {
    color: #b0bac9;
  }

  fieldset {
    border: 0;
    border-top: 1px solid #f16559;
  }

  .list-header {
    border-bottom: solid 1px #e4e8eb;
  }
  .appointment-lists {
    z-index: 99;
    //position: fixed;
    //width: calc(100% - 281px);
    height: calc(100vh - 197px);
    background-color: #fff !important;
    //-webkit-transition: all 0.5s ease;
    //transition: all 0.5s ease;
    border-right: 1px solid #e3e8eb;
    /* border-left: 1px solid #e3e8eb; */
    overflow-y: auto;
  }

  /*  .appointment-lists.resize-width {
    // width: 52%;
  } */

  .appointment-lists fieldset:first-child {
    margin-top: 10px;
  }

  .date-legend {
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #e4e8eb;
    background-color: #ffffff;
    padding: 1px 5px;
    font-size: 13px;
    font-weight: bold;
    color: #f16559;
    width: auto;
    margin-left: 25px;
    position: relative;
    top: -13px;
  }

  .join-call {
    background-color: #2ecd71;
    color: #ffffff;
    cursor: pointer !important;
  }
  .In-progress-call {
    width: 58px;
    border-radius: 4px;
    border: solid 1px #48bf7a;
    background-color: rgba(72, 191, 122, 0.2);
    color: #2e7a4e;
    cursor: pointer !important;
  }
  .rescheduled {
    width: 62px;
    border-radius: 4px;
    border: solid 1px #e88f11;
    background-color: rgba(232, 143, 17, 0.2);
    color: #955b0b;
  }
  .scheduled {
    color: #fff;
    background-color: #7fb1f6;
  }
  .calendar-header {
    border-bottom: 1px solid #e4e8eb;
  }
  .availability-btn {
    padding: 0.49rem 0.97rem;
    font-size: 0.75rem;
    font-weight: bold;
    color: #1e8fe1;
    border-color: #1e8fe1;
  }
  .availability-btn:hover {
    background-color: #1e8fe1;
    color: #fff;
  }
  .user-definied-pID {
    color: #4a4a4a;
  }
  .new-video-call-btn {
    font-size: 14px;
    padding: 0.354rem 0.75rem;
  }
  /* .weekly-navigation {
    border-bottom: 1px solid #e4e8eb;
    padding: 10px 10px;
    font-weight: bold;
  } */
  .weekly-navigation .fa {
    color: #007bff;
    cursor: pointer;
  }
  .response-msg {
    height: -moz-calc(100vh - 198px);
    height: -webkit-calc(100vh - 198px);
    height: calc(100vh - 198px);
  }
}
.btn-health {
  background-color: #508ee1 !important;
  color: #fff !important;
  cursor: pointer;
  font-family: Roboto-Bold;
  font-size: 12px !important;
}
.arrowColor {
  color: #1e8fe1;
  cursor: pointer;
}
.visitNameText {
  cursor: pointer;
  color: #1e8fe1;
}
.visitNameText:hover {
  cursor: pointer;
  color: #1e8fe1;
  text-decoration: underline;
}
.subHeading {
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}
.rowDiv {
  background-color: #eaf0f4;
}
.evaluateModalPhnoField {
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
}
.evaluateAddressField {
  color: #4a4a4a;
  font-weight: bold;
}
.cancelText {
  color: #666669;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
.activityNameLayout {
  position: relative;
  top: 0.6rem;
}
</style>
